import Loader from 'components/loaders/Loader';
import { ShouldRender } from 'components/ShouldRender';
import React, { useContext, useState } from 'react';
import { useLaundrySchedules } from 'services/laundry/schedules';
import { useSubmitResourceBooking } from 'services/laundry/submit-resource-booking';
import { LaundryBrikkModalContext } from 'components/brikks/home/LaundryService/components/LaundryBrikkContent/index';
import { ScheduleCard } from './components/ScheduleCard';
import styles from './styles.module.scss';

function formatDate(date) {
  return new Date(date)
    .toLocaleDateString('en-GB', {
      weekday: 'short',
      day: '2-digit',
      month: 'short',
    })
    .replace(',', '');
}

export function WhatAndWhenSection() {
  const { selectedDate, selectedEndDate, selectedResource } = useContext(
    LaundryBrikkModalContext,
  );
  const { laundrySchedules, isFetching } = useLaundrySchedules(
    selectedResource?.id,
  );
  const [submittedSchedule, setSubmittedSchedule] = useState();
  const { submitResourceBooking, isLoading } = useSubmitResourceBooking();
  const dayOfWeek = selectedDate.toLocaleDateString('en-GB', {
    weekday: 'long',
  });
  const formattedDate = formatDate(selectedDate);
  const formattedEndDate = formatDate(selectedEndDate);

  if (isFetching) return <Loader />;

  return (
    <div className={styles.cardsSectionWrapper}>
      {laundrySchedules?.schedules?.map((schedule, index) => (
        <ShouldRender
          key={index}
          condition={
            laundrySchedules?.available 
            && dayOfWeek === schedule?.day && (laundrySchedules?.scheduleType === 'daily' ? selectedEndDate : true)
          }
        >
          <ScheduleCard
            date={formattedDate}
            address={selectedResource?.address}
            from={schedule?.from}
            to={schedule?.to}
            dateTo={formattedEndDate}
            showRange={laundrySchedules?.scheduleType === 'daily'}
            isLoading={submittedSchedule === index && isLoading}
            onClick={() => {
              setSubmittedSchedule(index);
              submitResourceBooking({
                date: selectedDate,
                endDate: selectedEndDate,
                resourceId: selectedResource?.id,
                from: schedule?.from,
                to: schedule?.to,
                scheduleType: laundrySchedules?.scheduleType,
              });
            }}
          />
        </ShouldRender>
      ))}
    </div>
  );
}
